import axios from 'axios';

export async function getTickers() {
    const res = await axios.get(`/tickers`);
    return res.data.tickers as { stockTicker: string }[];
}
